import React from "react";
import TagService from "../../services/TagService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaTag extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: TagService,
            labels: {
                title: 'Lista de Tag(s)',
                btnNewRegister: 'Tag',
            },
            keyItem: 'idTag',
            urlForm: '/CadTag',
            itensFilter: ["idTag", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idTag}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}